export const OFFER_GROUP_DOCUMENT_TEMPLATE_MODEL =
  "offer-group-document-template";

const offerGroupDocumentTemplateModel = {
  name: "",
  description: "",
  documentType: "",
  sourceDocument: null,
  responseDocument: null,
  status: "",
  documents: {
    jsonApi: "hasMany",
    type: "file"
  }
};

export default offerGroupDocumentTemplateModel;
